export const environment = {
  production: true,
  baseUrl: 'https://www.preciate.com',
  helpUrl: 'https://help.preciate.com/',
};
